import { useFlag } from '@calendly/feature-check-react'
import { I18n } from '@calendly/i18n'

import { Spotlight } from 'components/core/spotlight'
import { MI_MEETINGS_TOUR } from 'features/meeting_intelligence/constants'
import { useURLParams } from 'features/meeting_intelligence/hooks'
import { handleDefaults } from 'features/meeting_intelligence/utils'
import { useTrack, useTrackOnce } from 'hooks/analytics_events/useTrack'

const STEP_ONE_SHOWN = {
  name: 'Tooltip Shown',
  properties: {
    tooltip_name: 'prepare_your_meetings',
    tooltip_flow: 'ai_notetaker_tour',
    tooltip_location: 'meetings_ai_notetaker_icon',
  }
}

const STEP_ONE_CLICKED = {
  name: 'Tooltip Clicked',
  properties: {
    tooltip_name: 'prepare_your_meetings',
    tooltip_flow: 'ai_notetaker_tour',
    tooltip_location: 'meetings_ai_notetaker_icon',
    action: 'tooltip_clicked'
  }
}

const STEP_ONE_DISMISSED = {
  name: 'Tooltip Clicked',
  properties: {
    tooltip_name: 'prepare_your_meetings',
    tooltip_flow: 'ai_notetaker_tour',
    tooltip_location: 'meetings_ai_notetaker_icon',
    action: 'dismissed'
  }
}

export const StepOne = ({ isVisible = true }) => {
  const track = useTrack()
  const { findParam, replaceParam, removeParam } = useURLParams()
  const showTooltip = findParam(MI_MEETINGS_TOUR.STEP_ONE) && isVisible
  const hasMsTeamsFlag = useFlag('ms_teams_notetaker')

  useTrackOnce(showTooltip, STEP_ONE_SHOWN)

  const handleContinue = (e) => {
    handleDefaults(e)
    track(STEP_ONE_CLICKED)
    replaceParam(MI_MEETINGS_TOUR.STEP_TWO, MI_MEETINGS_TOUR.STEP_ONE)
  }

  const handleDismiss = (e) => {
    handleDefaults(e)
    track(STEP_ONE_DISMISSED)
    removeParam(MI_MEETINGS_TOUR.STEP_ONE)
  }

  if (!showTooltip) return null

  return (
    <Spotlight
      headingText={I18n.t('publisher.meeting_intelligence.tour.step_one.title')}
      bodyText={hasMsTeamsFlag
        ? I18n.t('publisher.meeting_intelligence.tour.step_one.body_text_with_teams')
        : I18n.t('publisher.meeting_intelligence.tour.step_one.body_text')}
      primaryButtonLabel={I18n.t('publisher.meeting_intelligence.tour.next')}
      footerText={I18n.t('publisher.meeting_intelligence.tour.step_one.progress')}
      onClickPrimary={handleContinue}
      placement="bottom-left"
      offset={10}
      onClose={handleDismiss}
      outsideClickDetectionEnabled={false}
    />
  )
}
